

import { Component, Vue, Watch, Prop, InjectReactive, Inject } from "vue-property-decorator"
import { namespace, Getter, Action, Mutation } from "vuex-class"

import vSelect from "vue-select"
import CaseFileDisplay from "./CaseFileDisplay.vue"
import Confirmation from "../../Confirmation.vue"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"

import { CaseDetails, CaseField, CaseAudit } from "@/types"
import CaseFile from "@/types/caseFile"
import { LayoutLocations } from "@/types/templateLayout"
import api from "@/services/api"
import FileService from "@/services/file-service"
import { ui } from "@/types/ui"

const caseStore = namespace("cases")

@Component({
	components: {
		"case-file": CaseFileDisplay,
		"v-select": vSelect,
		"scrollbar": VuePerfectScrollbar,
		"confirm": Confirmation
	}
})
export default class CaseFileUpload extends Vue {
	@Inject("fileService") fileService!: FileService;

	$refs!: {
		confirmModal: Confirmation,
		fileInput: HTMLInputElement
	}

	@Prop({ type: Boolean, default: false })
	public creatingNewCase!: boolean;

	@Prop({ type: String || null, default: null })
	public fieldId!: string | null;

	@Prop({ type: String || null, default: null })
	public fieldName!: string | null;

	@Prop({ type: Boolean, default: false })
	public showUploadingFiles!: boolean;

	@Prop({ type: Boolean, default: false })
	public displayAsList!: boolean;

	@Prop({ type: Boolean, default: false })
	viewOnly!: boolean;

	@Prop()
	public caseFiles!: CaseFile[];

	@Prop({ default: null })
	public layout!: LayoutLocations | null;

	private uploadFieldName: any = "files";
	private dragging: boolean = false;
	rightMenu = LayoutLocations.RightHandMenu

	@Prop()
	public ui!:ui;

	public get uploadingFiles () {
		if (!this.fileService) {
			return []
		}
		return this.fileService.uploadFiles.filter((file: any) => file.fieldId === this.fieldId)
	}

	private async onChange (event: any): Promise<void> {
		this.dragging = false
		if (this.creatingNewCase) {
			return
		}

		if (this.viewOnly) return

		let files = (event.target.files || event.dataTransfer.files) as any[]

		const uploadFiles: any[] = []
		files.forEach(file => {
			const newFile = {
				fieldId: this.fieldId,
				name: file.name,
				fileData: file,
				uploading: false,
				uploadPercentage: 0,
				failed: false,
				success: false,
				error: null,
				uploadRun: false,
				errorShown: false
			}

			uploadFiles.push(newFile)
		})

		this.fileService.addFiles(uploadFiles)

		this.$refs.fileInput.value = ""
	}

	deleteFile (file: CaseFile) {
		this.$refs.confirmModal.open(file.filename, () => {
			this.fileService.deleteFile(file.id)
		})
	}

	showErrorToast (file: any) {
		if (!file.errorShown) {
			this.$bvToast.toast(`File upload failed for "${file.name}". See console for error.`, {
				title: "Upload Error",
				variant: "danger",
				solid: true,
				autoHideDelay: 5000
			})
			file.errorShown = true
			console.error(file.error) // Log error instead of displaying full stack error to user
		}
	}
}
